import React from "react";

export interface KpiItem {
  key: string;
  label: string;
  value: React.ReactNode;
  /** Classe de cor do valor (ex.: tom do SLA). */
  valueClassName?: string;
  /** Linha pequena sob o valor. */
  hint?: React.ReactNode;
  /** Clicável: aplica o filtro correspondente na tela (o indicador "conversa" com a lista). */
  onClick?: () => void;
  /** Filtro do indicador já aplicado. */
  active?: boolean;
}

/** Faixa de indicadores compactos, numa linha no desktop. Indicador clicável vira filtro. */
const KpiStrip: React.FC<{ items: KpiItem[] }> = ({ items }) => (
  <ul className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-5">
    {items.map((k) => {
      const corpo = (
        <>
          <span className="block truncate text-xs font-medium text-gray-700 dark:text-gray-300">{k.label}</span>
          <span
            className={`mt-0.5 block font-display text-xl font-bold tabular-nums ${
              k.valueClassName ?? "text-navy-700 dark:text-white"
            }`}
          >
            {k.value}
          </span>
          {k.hint && <span className="block truncate text-[11px] text-gray-600 dark:text-gray-400">{k.hint}</span>}
        </>
      );
      const base = "h-full w-full rounded-xl border px-3 py-2 text-left";
      const tom = k.active
        ? "border-dv-blue-500 bg-dv-blue-500/10 dark:border-dv-cyan-400"
        : "border-gray-100 bg-gray-50 dark:border-white/10 dark:bg-navy-900";
      return (
        <li key={k.key} className="min-w-0">
          {k.onClick ? (
            <button
              type="button"
              onClick={k.onClick}
              aria-pressed={!!k.active}
              className={`${base} ${tom} transition-colors hover:border-dv-blue-300 dark:hover:border-white/30`}
            >
              {corpo}
            </button>
          ) : (
            <div className={`${base} ${tom}`}>{corpo}</div>
          )}
        </li>
      );
    })}
  </ul>
);

export default KpiStrip;
